<form
  [formGroup]="form"
  (ngSubmit)="onSave()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <span class="text-[18px] font-black">
        <i
          [class.pi]="true"
          [class.pi-file-arrow-up]="true"
          style="font-size: 2rem"></i>
        DESPLEGAR SISTEMA DE IA
      </span>
      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="cancel()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 3 de 6</span>
      <h1 class="font-bold text-[30px] pb-8">Desplegar sistema de IA</h1>

      <h2 class="font-bold text-[24px] pb-6">Cuestiones Técnicas</h2>

      <h3 class="font-bold text-[18px] pb-6">Alojamiento</h3>

      <label
        class="text-[16px]"
        for="aiInfrastructure">
        Infraestructura
      </label>
      <desy-textarea
        formControlName="aiInfrastructure"
        placeholder="Escriba aquí información sobre la infraestructura"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>

      <h3 class="font-bold text-[18px] py-6">Integración</h3>

      <label
        class="text-[16px]"
        for="integrationMode">
        Modo de integración con la plataforma corporativa
      </label>
      <desy-textarea
        formControlName="integrationMode"
        placeholder="Escriba aquí el modo de integración con la plataforma corporativa"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>

      <h3 class="font-bold text-[18px] py-6">Datos de entrenamiento</h3>

      <label
        class="text-[16px]"
        for="dataSource">
        Origen de los datos
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="dataSource"
        placeholder="Escriba aquí el origen de los datos"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <ng-container *ngIf="getError(form, 'dataSource', formSubmitted()) as error; else dataSourceInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #dataSourceInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>
      </ng-template>

      <label
        class="text-[16px] pt-4"
        for="timePeriod">
        Periodo temporal cubierto
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="timePeriod"
        placeholder="Escriba aquí el periodo temporal cubierto"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'timePeriod', formSubmitted()) as error; else timePeriodInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #timePeriodInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="grid grid-cols-2 items-end mt-4">
        <div>
          <label class="text-[16px] mb-2 block">Tipo de datos*</label>
          <p-multiSelect
            formControlName="dataCategory"
            [options]="dataCategoryOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecciona una o más categorías"
            [showToggleAll]="false"
            [showHeader]="false"
            styleClass="w-full"></p-multiSelect>
        </div>

        <div></div>

        <div class="flex flex-col">
          <label
            class="text-[16px] mt-4 block"
            for="qualityAccreditation">
            Acreditación de la calidad de los datos
            <span *ngIf="highRiskFieldsRequired()">*</span>
          </label>
          <span class="text-[14px] text-neutral-dark block">Con CSV</span>
          <desy-input
            id="qualityAccreditation"
            [classes]="'w-full'"
            [placeholder]="'Supervisor-1, Supervisor-2...'"
            formControlName="qualityAccreditation"></desy-input>
          <desy-error-message *ngIf="getError(form, 'qualityAccreditation', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <label
        class="text-[16px] pt-4"
        for="inputDataSource">
        Origen de la fuente de datos en tiempo real
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="inputDataSource"
        placeholder="Escriba aquí el origen de la fuente de datos en tiempo real"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <ng-container *ngIf="getError(form, 'inputDataSource', formSubmitted()) as error; else inputDataSourceInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #inputDataSourceInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>
      </ng-template>

      <h3 class="font-bold text-[18px] py-6">Código</h3>

      <label
        class="text-[16px]"
        for="sourceCode">
        Enlace al código fuente
        <span *ngIf="highRiskFieldsRequired()">*</span>
      </label>
      <desy-textarea
        formControlName="sourceCode"
        placeholder="Escriba aquí el enlace al código fuente"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'sourceCode', formSubmitted()) as error; else sourceCodeInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #sourceCodeInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>
    </div>
  </div>
</form>
